//import axios from "axios";
import React, { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

function TutupBulan() {
  const { periode, bulan, api } = useGlobalContext(); 

  const [message, setMessage] = useState("");
                                                    
  const currentYear = periode.toString().substring(0,4) 
  const currentMonth = parseInt(periode.toString().substring(4,6)) - 1;

  const nextMonth = (currentMonth + 1) % 12;
  const nextYear = currentMonth === 11 ? currentYear + 1 : currentYear;

  const periodenext = nextYear.toString() + (nextMonth + 1).toString().padStart(2,'0');
  const tglperiodebaru = nextYear.toString() + "-" +  (nextMonth + 1).toString() + "-01";

  const [loading, setLoading] = useState(false);

  const fetchData = async (url) => {
    try {
      const response = await api.get(url,{
        credentials: "include",
        headers: {
          "Accept": "application/json",            
          "Content-Type": "application/json"
        }      
      });
      return response.data;
    } catch (error) {
      console.error("Error fetch:", error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const [dataSimpanan, dataPinjaman, dataManasuka, dataHariraya] = await Promise.all(
        [
          fetchData(`/api/tutup/rekeningsimpananusp/${periode}/${periodenext}`),
          fetchData(`/api/tutup/rekeningpinjaman/${periode}/${periodenext}`),
          fetchData(`/api/tutup/rekeningsimpananmanasuka/${periode}/${periodenext}`),
          fetchData(`/api/tutup/rekeningsimpananhariraya/${periode}/${periodenext}`),          
        ]
      );
      
      if (!Array.isArray(dataSimpanan) || !Array.isArray(dataPinjaman) || !Array.isArray(dataManasuka) || !Array.isArray(dataHariraya)) {
        console.error("Data Simpanan bukan array:");
        setLoading(false);
        return;
      }          
      
      const recordSimpanan = dataSimpanan.map((item) => ({
        periode :  item.periode,
        noanggota : item.noanggota,
        kode_uk : item.kodeuk,
        spokok : item.spokok,
        mutspokok : 0,
        outspokok : 0,
        swajib : item.swajib,
        mutswajib: 0,
        outswajib: 0,
        shariraya: item.shariraya,
        mutshariraya: 0,
        outshariraya: 0,
        smanasuka: item.smanasuka,
        mutsmanasuka: 0,
        outsmanasuka: 0,
        skepsek: item.skepsek,
        mutskepsek: 0,
        outskepsek: 0,
        mutsde2: 0,
        outde2: 0,
        sde2: 0,
        dpha: 0,
        mutdpha: 0,
        outdpha: 0,
        aktif: item.aktif,
        tutupblnini: item.tutupblnini,
      }));

      const recordPinjaman =  dataPinjaman.map((item) => ({
        periode : item.periode,
        noanggota : item.noanggota,
        kode_uk : item.kodeuk,
        sldawal_ua : item.sldunit_a,
        sldawal_ub : item.sldunit_b, 
        sldawal_uc : item.sldunit_c,
        angsur_a : 0,
        angsur_b : 0,
        angsur_c : 0,
        layanan_a : 0,
        layanan_b : 0,
        layanan_c : 0,
        sldunit_a : item.sldunit_a,
        sldunit_b : item.sldunit_b,
        sldunit_c : item.sldunit_c,
        germen_a  : 0,
        germen_b  : 0,
        germen_c  : 0,
        sldgermen_a : item.sldgermen_a,
        sldgermen_b : item.sldgermen_b,
        sldgermen_c : item.sldgermen_c,
        jasa_a : 0,
        jasa_b : 0,
        jasa_c : 0,
        sldjasa_a : item.sldjasa_a,
        sldjasa_b : item.sldjasa_b,
        sldjasa_c : item.sldjasa_c,
        tutup : 0
      }));

      const recordManasuka =  dataManasuka.map((item) => ({
        periode : item.periode,
        noanggota : item.noanggota,
        saldoawal : item.saldoakh,
        setoran : 0,
        penarikan : 0,
        saldoakh : item.saldoakh,
        saldoawaljasa : item.saldojasa, 
        terimajasa : 0,
        tarikjasa : 0,
        saldojasa : item.saldojasa,
        pajakjasa : 0,   
      }));

      const recordHariraya =  dataHariraya.map((item) => ({
        periode : item.periode,
        noanggota : item.noanggota,
        setoran : 0,
        penarikan : 0,
        saldoakh : item.saldoakh,
        terimajasa : 0,
        tarikjasa : 0,
        saldojasa : item.saldojasa,
        pajakjasa : 0,   
      }));

      const periodeNew = {
        periode : tglperiodebaru,
        periode2: periodenext,
        status : 1,
        pmanasuka : 0,
        phariraya : 0
      };

      await Promise.all(
        recordSimpanan.map(record => 
          api.post('/api/tutup/rekeningsimpananusp', record)
        )
      );

      await Promise.all(
        recordPinjaman.map(record => 
          api.post('/api/tutup/rekeningpinjaman', record)
        )
      );

      await Promise.all(
        recordManasuka.map(record => 
          api.post('/api/tutup/rekeningmanasuka', record)
        )
      );

      await Promise.all(
        recordHariraya.map(record => 
          api.post('/api/tutup/rekeninghariraya', record)
        )
      );

      try{
        await api.patch(`/api/tutup/periodeupdate/${periode}`);
      }catch (error) {
        console.error('Error submittiing data:', error);
      };

      try {
        await api.post('/api/tutup/periodenew', periodeNew);
      }catch (error) {
        console.error('Error submitting data:', error);
      };

      setMessage("Proses tutup bulan berhasil!");
      setTimeout(() => {        
        localStorage.removeItem('pengguna'); // Hapus data sesi pengguna
        window.location.href = '/login'; // Redirect ke halaman login
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card card-info" style={{ width: "400px" }}>
        <div className="card-header text-center">
          <h5 className="card-title">Proses Tutup Bulan</h5>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Periode</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={`${bulan[currentMonth]} ${currentYear}`} readOnly />
            </div>
          </div>
          <div className="form-group row mt-3">
            <label className="col-sm-5 col-form-label">Periode Selanjutnya</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={`${bulan[nextMonth]} ${nextYear}`} readOnly />
            </div>
          </div>
          {message && <div className="alert alert-info mt-4 text-center" role="alert">{message}</div>} 
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={loading}>
           {loading ? "Memproses..." : "Proses"}
          </button>
          {loading && (
            <div className="text-center mt-2">
              <span className="text-info font-bold">Memproses data, harap tunggu...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TutupBulan;   